let routes = [
    {
        path: '/macroscopic',
        name: '宏观',
        component: () => import('@/views/macroscopic/index'),
    },
    {
        path: 'macroscopic/twoPage/industry',
        name: '宏观行业动态二级页',
        component: () => import('@/views/macroscopic/twoPage/industry')
    },
    {
        path: 'macroscopic/industry',
        name: '宏观行业动态详情页',
        component: () => import('@/views/macroscopic/detail/industry')
    },
]

export default routes
